var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-container',[_c('v-data-table',{attrs:{"headers":_vm.titulos,"items":_vm.dados,"hide-actions":"","search":_vm.search,"no-data-text":"Sem resultados"},scopedSlots:_vm._u([{key:"items",fn:function(props){return _vm._l((_vm.titulos),function(t,i){return _c('td',{key:i,staticClass:"text-xs-center"},[(t.value!='acoes')?_c('span',[_vm._v(_vm._s(props.item[t.value]))]):_vm._e()])})}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5a3c522","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CTable.vue
// module id = 853
// module chunks = 0